import { getAltImageSuggestions } from '@wix/ambassador-promote-seo-v1-alt-text-suggestions/http';
export const fetchSingleAltTextSuggestions = async (httpClient, errorHandler, t, request) => {
  try {
    const {
      data
    } = await errorHandler.withErrorHandler(async () => httpClient.request(getAltImageSuggestions(request)), {
      errorCodesMap: {
        applicationError: {
          OPENAI_API_CREATION_FAILURE: () => ({
            message: t('accessibility-wizard.common.prefix-status-icon.failed-to-generate')
          }),
          OPENAI_API_GET_COMPLETION_FAILURE: () => ({
            message: t('accessibility-wizard.common.prefix-status-icon.failed-to-generate')
          }),
          OPENAI_API_IS_MODERATION_FLAGGED_FAILURE: () => ({
            message: t('accessibility-wizard.common.prefix-status-icon.failed-to-generate')
          })
        }
      }
    });
    return data.altTextSuggestions || {};
  } catch (error) {
    console.error('Failed to fetch single alt text suggestions', error);
    throw error;
  }
};
//# sourceMappingURL=fetch-single-alt-text-suggestions.js.map